<template>
  <v-container>

    <v-row>
      <v-col md="12">
        <h1 class="font-weight-medium">{{ $t('Administación de Eventos DO Cava') }}</h1>
        <v-btn v-if="isAdmin" to="/eventos/add" large color="primary" dark>
          {{ $t('Añadir evento') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4">
        <v-text-field
            :label="$t('Nombre del evento')"
            filled
            v-model="searchtext"
            maxlength="250"

        ></v-text-field>
      </v-col>
      <v-col md="2" style="padding-top:20px">
        <v-btn @click="search" large color="primary" dark>
          {{ $t('buscar') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">{{ $t('Nombre del evento') }}</th>
              <th class="text-left">{{ $t('Estado') }}</th>
              <th class="text-left">{{ $t('Descripción') }}</th>
              <th class="text-left">{{ $t('País') }}</th>
              <th class="text-left">{{ $t('Fecha límite de inscripción') }}</th>
              <th class="text-left"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data" :key="item.name">
              <td>
                <router-link :to="{name:'eventoadmin', params: {id: item.uuid}}">
                  <span v-if="$i18n.locale=='es'">{{ item.nombre_es }}</span>
                  <span v-else>{{ item.nombre_ca }} </span>
                </router-link>
              </td>
              <td>
                <span v-if="item.state==-1">Cancelado</span>
                <span v-else-if="item.state==1">Publicado</span>
                <span v-else-if="item.state==2">Enviado</span>
                <span v-else="item.state==-1">Borador</span>{{item.state}}
              </td>
              <td>
                <span v-if="$i18n.locale=='es'">{{ item.descripcion_breve_es}}</span>
                <span v-else>{{ item.descripcion_breve_ca }}</span>
              </td>
              <td v-if="item.dirreccions.length > 0">{{ item.dirreccions[0].pais }}</td>
              <td v-else>--</td>
              <td>{{ item.fecha_limite }}</td>
              <td>
                <v-btn :to="{name:'eventoadmin', params: {id: item.uuid}}" color="primary" dark small href="">
                  {{ $t('Ver datatos') }}
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-pagination
          v-model="page"
          :length="length"
          :page="page"
          total-visible="5"
      ></v-pagination>
    </v-row>
  </v-container>
</template>


<script>

import axios from "axios"
import {mapGetters} from "vuex";
import 'url-search-params-polyfill';



export default {
  data() {
    return {
      page: 1,
      searchtext: "",
      length: 6,
      data: []
    };
  },
  computed: {
    ...mapGetters([
      "isAdmin", "isLoggedIn"
    ])
  },
  methods: {

    df(d) {
      let current_datetime = new Date(d)
      return current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate()
    },
    search() {
      let data = {};

      if (this.searchtext != "") {
        data.nombre__unaccent__icontains = this.searchtext
      }

      data.page = this.page

      const searchParams = new URLSearchParams(data);
      const jwt = this.$store.state.jwt

      const config = {
        headers: {Authorization: "Bearer " + jwt},
        params: searchParams,
      };
      return axios.get(this.$store.state.endpoints.evento, config)
          .then((response) => {
            this.data = response.data.results
            this.length = Math.ceil(response.data.count / 10)
          })
          .catch((error) => {
            console.error(error)
          })
    },
  },
  watch: {
    // whenever question changes, this function will run
    page: function (newQuestion, oldQuestion) {
      this.search()
    }
  },
  mounted() {
    this.search()
  }

};
</script>

<style>
.disable-events {
  pointer-events: none
}

</style>





